import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../lib/firebase';

export default function Login() {
  const { loginConEmail, loginConGoogle } = useAuth();
  const navigate  = useNavigate();
  const [errore, setErrore]           = useState('');
  const [caricamento, setCaricamento] = useState(false);
  const [resetEmail, setResetEmail]   = useState('');
  const [resetInviato, setResetInviato] = useState(false);
  const [mostraReset, setMostraReset] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  async function onSubmit(dati) {
    setErrore('');
    setCaricamento(true);
    try {
      await loginConEmail(dati.email, dati.password);
      navigate('/scegli-societa');
    } catch (e) {
      setErrore(traduciErrore(e.code));
    } finally {
      setCaricamento(false);
    }
  }

  async function onReset() {
    if (!resetEmail) { setErrore('Inserisci la tua email per reimpostare la password'); return; }
    if (!/\S+@\S+\.\S+/.test(resetEmail)) { setErrore('Inserisci un indirizzo email valido'); return; }
    setCaricamento(true);
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetInviato(true);
      setErrore('');
    } catch (e) {
      setErrore(traduciErrore(e.code));
    } finally {
      setCaricamento(false);
    }
  }

  async function onGoogle() {
    setErrore('');
    setCaricamento(true);
    try {
      const { profiloCompleto } = await loginConGoogle();
      if (!profiloCompleto) {
        navigate('/completa-profilo');
      } else {
        navigate('/scegli-societa');
      }
    } catch (e) {
      setErrore(traduciErrore(e.code));
    } finally {
      setCaricamento(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 overflow-y-auto" style={{ paddingBottom: "2rem" }}
         style={{ paddingTop: "env(safe-area-inset-top)" }}>

      {/* Logo / Titolo */}
      <div className="mb-8 text-center">
                  <img src="https://firebasestorage.googleapis.com/v0/b/fcbachecascherma.firebasestorage.app/o/bacheca_scherma_icon.png?alt=media&token=1e294cb8-eb47-468b-a302-b71de444ec63" alt="Bacheca Scherma" className="w-16 h-16 rounded-2xl mx-auto mb-4" style={{objectFit: "cover"}} />
        <h1 className="text-2xl font-bold text-scherma-navy">Bacheca Scherma</h1>
        <p className="text-gray-500 text-sm mt-1">Accedi al tuo account</p>
      </div>

      <div className="w-full max-w-sm bg-white rounded-2xl shadow-sm border
                      border-gray-100 p-6">

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              autoComplete="email"
              className="w-full px-4 py-3 rounded-xl border border-gray-200
                         focus:outline-none focus:ring-2 focus:ring-scherma-blue
                         text-gray-900 text-sm"
              placeholder="nome@esempio.it"
              {...register('email', {
                required: 'Email obbligatoria',
                pattern:  { value: /\S+@\S+\.\S+/, message: 'Email non valida' }
              })}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              autoComplete="current-password"
              className="w-full px-4 py-3 rounded-xl border border-gray-200
                         focus:outline-none focus:ring-2 focus:ring-scherma-blue
                         text-gray-900 text-sm"
              placeholder="••••••••"
              {...register('password', { required: 'Password obbligatoria' })}
            />
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>
            )}
          </div>

          {errore && (
            <div className="bg-red-50 border border-red-100 rounded-xl px-4 py-3">
              <p className="text-red-600 text-sm">{errore}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={caricamento}
            className="w-full bg-scherma-blue text-white py-3 rounded-xl
                       font-medium text-sm hover:bg-blue-700 transition-colors
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {caricamento ? 'Accesso in corso...' : 'Accedi'}
          </button>

        </form>

        {!mostraReset ? (
          <button type="button" onClick={() => setMostraReset(true)}
            className="text-xs text-scherma-blue text-right w-full mb-2 hover:underline">
            Password dimenticata?
          </button>
        ) : (
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-4">
            {resetInviato ? (
              <p className="text-sm text-green-700">
                Email inviata! Controlla la tua casella di posta.
              </p>
            ) : (
              <>
                <p className="text-sm text-gray-700 mb-2">
                  Inserisci la tua email per ricevere il link di reset:
                </p>
                <input type="email"
                  value={resetEmail}
                  onChange={e => setResetEmail(e.target.value)}
                  placeholder="nome@esempio.it"
                  className="w-full px-3 py-2 rounded-lg border border-gray-200
                             focus:outline-none focus:ring-2 focus:ring-scherma-blue
                             text-sm mb-2"
                />
                <div className="flex gap-2">
                  <button onClick={onReset} disabled={caricamento}
                    className="flex-1 bg-scherma-blue text-white py-2 rounded-lg
                               text-sm font-medium disabled:opacity-50">
                    {caricamento ? 'Invio...' : 'Invia email'}
                  </button>
                  <button onClick={() => { setMostraReset(false); setErrore(''); }}
                    className="text-sm text-gray-400 px-3">
                    Annulla
                  </button>
                </div>
              </>
            )}
          </div>
        )}

        <div className="relative my-5">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-100" />
          </div>
          <div className="relative flex justify-center">
            <span className="bg-white px-3 text-xs text-gray-400">oppure</span>
          </div>
        </div>

        <button
          onClick={onGoogle}
          disabled={caricamento}
          className="w-full flex items-center justify-center gap-3 border
                     border-gray-200 py-3 rounded-xl text-sm font-medium
                     text-gray-700 hover:bg-gray-50 transition-colors
                     disabled:opacity-50"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continua con Google
        </button>

        <p className="text-center text-sm text-gray-500 mt-6">
          Non hai un account?{' '}
          <Link to="/registrazione" className="text-scherma-blue font-medium">
            Registrati
          </Link>
        </p>

      </div>
    </div>
  );
}

function traduciErrore(code) {
  const errori = {
    'auth/invalid-credential':      'Email o password non corretti.',
    'auth/user-not-found':          'Nessun account con questa email.',
    'auth/wrong-password':          'Password non corretta.',
    'auth/too-many-requests':       'Troppi tentativi. Riprova tra qualche minuto.',
    'auth/user-disabled':           'Account disabilitato. Contatta l\'amministratore.',
    'auth/network-request-failed':  'Errore di rete. Controlla la connessione.',
  };
  return errori[code] || 'Si è verificato un errore. Riprova.';
}
